import { TeiaQuantityTakeoffColumn } from '../types';
import { prettyColumnName } from './table-utils';

export const teiaQuantityTakeoffColumnDTO = (column: string): TeiaQuantityTakeoffColumn => {
  return {
    title: prettyColumnName(column),
    value: column,
  };
};
